import { Logo } from "@";
import React, { memo } from "react";

export const AuthLayoutSkeleton = memo(() => {
  return (
    <div className="fixed inset-0 z-50 flex h-screen w-screen items-center justify-center bg-gradient-to-br from-white via-purple-50/40 to-white dark:from-gray-900 dark:via-gray-900 dark:to-gray-950">
      {/* Decorative orbs */}
      <span
        aria-hidden
        className="pointer-events-none absolute -start-24 top-1/3 h-72 w-72 rounded-full bg-gradient-to-br from-purple-200/40 to-transparent blur-3xl dark:from-purple-700/20"
      />
      <span
        aria-hidden
        className="pointer-events-none absolute -end-32 bottom-1/4 h-80 w-80 rounded-full bg-gradient-to-br from-purple-300/30 to-transparent blur-3xl dark:from-purple-800/20"
      />

      <div className="relative flex flex-col items-center gap-6">
        <div className="animate-pulse">
          <Logo noStyle />
        </div>
        {/* Refined progress dots */}
        <div className="flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-purple-700 [animation-delay:-0.3s] dark:bg-purple-400" />
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-purple-700 [animation-delay:-0.15s] dark:bg-purple-400" />
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-purple-700 dark:bg-purple-400" />
        </div>
      </div>
    </div>
  );
});

export const BoxesSkeleton = memo(() => {
  return (
    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
      {Array(6)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className="relative h-16 w-full overflow-hidden rounded-2xl border border-gray-100 bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100 dark:border-gray-800 dark:from-gray-800 dark:via-gray-800/60 dark:to-gray-800"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <span
              aria-hidden
              className="pointer-events-none absolute inset-0 -translate-x-full animate-[loaderShimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent dark:via-white/5"
            />
          </div>
        ))}
      <style>{`@keyframes loaderShimmer { 100% { transform: translateX(100%); } }`}</style>
    </div>
  );
});
